export const ARTICLE_TEMPLATE_COLUMNS = [
  { header: "Barkodi", key: "barcode", width: 24 },
  { header: "Emërtimi *", key: "name", width: 38 },
  { header: "Përshkrimi", key: "description", width: 40 },
  { header: "Grupi *", key: "group", width: 26 },
  { header: "Kategoria *", key: "category", width: 26 },
  { header: "Njësia matëse *", key: "unit", width: 22 },
  { header: "TVSH *", key: "vat", width: 26 },
  { header: "Çmimi i blerjes me TVSH", key: "purchasePrice", width: 28 },
  { header: "Çmimi i shitjes me TVSH *", key: "salesPrice", width: 28 },
  { header: "Aktiv", key: "active", width: 16 },
];
